import { post, postJson, get } from './axios'

const RESOURCE_BASE_PATH = '/public';

/*
 * 获取品牌
 * */
export const getBrandList = p => post(`${RESOURCE_BASE_PATH}/getBrandList`, p);

/*
 * 获取淘宝类目
 * */
export const getTaobaocats = p => post(`${RESOURCE_BASE_PATH}/getTaobaocats`, p);

/*
 * 获取店铺类目
 * */
export const getSellercats = p => post(`${RESOURCE_BASE_PATH}/getSellercats`, p);

/*
 * 获取淘宝商品信息
 * */
export const getTaobaoItemList = p => postJson(`${RESOURCE_BASE_PATH}/getTaobaoItemList`, p);

/*
 * 获取系统分组模板
 * */
export const getTemplate = p => postJson(`${RESOURCE_BASE_PATH}/getTemplate`, p);

/*
 * 获取我的分组模板
 * */
export const getMineTemplate = p => postJson(`${RESOURCE_BASE_PATH}/getMineTemplate`, p);

/*
 * 获取最近使用模板
 * */
export const getRecentlyTemplate = p => postJson(`${RESOURCE_BASE_PATH}/getRecentlyTemplate`, p);

/*
 * 获取优惠券
 * */
export const getCouponList = p => postJson(`${RESOURCE_BASE_PATH}/getCouponList`, p);

/*
 * 转换短链接
 * */
export const getShortUrl = p => postJson(`${RESOURCE_BASE_PATH}/getShortUrl`, p);

/*
 * 获取店铺地址短链接
 * */
export const getShopShortUrl = p => postJson(`${RESOURCE_BASE_PATH}/getShopShortUrl`, p);

/*
 * 保存短信模板
 * */
export const addMineTemplate = p => post(`${RESOURCE_BASE_PATH}/addMineTemplate`, p);

/*
 * 发送测试短信
 * */
export const testSend = p => postJson(`${RESOURCE_BASE_PATH}/testSend`, p);

/*
 * 删除我的模板
 * */
export const deleteMineTemplate = p => post(`${RESOURCE_BASE_PATH}/deleteMineTemplate`, p);

/*
 * 加入黑名单
 * */
export const addBlacklist = p => post(`${RESOURCE_BASE_PATH}/addBlacklist`, p);

/*
 * 发送验证码
 * */
export const sendSmsVerifyCode = p => post(`${RESOURCE_BASE_PATH}/sendSmsVerifyCode`, p);

/***
 * 查询商家签名，仅查询状态为审核成功的
 * @param p
 */

export const querySellerSign = p => post(`${RESOURCE_BASE_PATH}/querySellerSign`, p)


/**
 *发送短信（根据查询条件）
 */
// export const sendSmsMessage = p => postJson(`/api/sendMsg/sendToBuyer`, p);
/**
 *发送短信（根据查询条件）
 */
export const sendSmsMessage = p => postJson(`/api/sendMsg/memberListSendByQueryResult`, p);

/**
 *发送短信（勾选）
 */
export const sendSmsMessageChoose = p => postJson(`/api/sendMsg/shopBuyerSendToInputMobiles`, p);


/*
 * 地区查询
 * */
export const getSysAreaMessage = p => post(`${RESOURCE_BASE_PATH}/getSysAreaMessage`, p);

/*
表格查询  
*/
export const getUploadfileList = p => postJson(`${RESOURCE_BASE_PATH}/getUploadfileList`, p);


/** *
 * 指定号码发送 指定号码发送 涉及全部输入号码发送的接口
 * @param p
 */
export const sendToInputMobiles = p => postJson(`/api/sendMsg/sendToInputMobiles`, p)

/**
 * 修改客户单价
 */
// /public/modifyUnitPrice
export const modifyUnitPrice = p => post(`${RESOURCE_BASE_PATH}/modifyUnitPrice`, p);

//根据会员ID集, 查询需要的信息
export const queryBuyerDetail = p => post(`${RESOURCE_BASE_PATH}/queryBuyerDetail`, p);

export const queryMenu = p => post(`${RESOURCE_BASE_PATH}/queryMenu`, p);
//发送短信之前的验证
export const authenticationSend = p => post(`${RESOURCE_BASE_PATH}/authenticationSend`, p);


// 退货原因 /public/getRefundReason

export const getRefundReason = p => post(`${RESOURCE_BASE_PATH}/getRefundReason`, p);

//违法词校验
export const detectionSmsKeyword = p => post(`${RESOURCE_BASE_PATH}/detectionSmsKeyword`, p);
//敏感词获取
export const getSmsSensitiveWordList = p => post(`${RESOURCE_BASE_PATH}/getSmsSensitiveWordList`, p);

//删除上传的文件
export const deleteUploadfile = p => post(`${RESOURCE_BASE_PATH}/deleteUploadfile`, p);
//获取标题
export const queryTemplateTitle = p => post(`${RESOURCE_BASE_PATH}/queryTemplateTitle`, p);

//修改商品名称缩写 
export const updateTaobaoItemTitle = p => post(`${RESOURCE_BASE_PATH}/updateTaobaoItemTitle`, p);

//树形地区querySysAreaMessage
export const querySysAreaMessage = p => post(`${RESOURCE_BASE_PATH}/querySysAreaMessage`, p);


export const GetProvinceList = p => post(`${RESOURCE_BASE_PATH}/querySysAreaMessage`, p)

//物流链接  /openController/logisticsAdvertiseLinkPage

export const logisticsAdvertiseLinkPage = p => get(`/api/openController/logisticsAdvertiseLinkPage`, p)

//根据文件ID，查询文件详细信息
export const queryFileDetail = p => post(`${RESOURCE_BASE_PATH}/queryFileDetail`, p);

/***
 * 根据商品NUM_ID，查询商品详细信息 
 * @param p
 */

export const queryItemDetail = p => post(`${RESOURCE_BASE_PATH}/queryItemDetail`, p)

//点击模板使用 
export const saveRecentTemplate = p => post(`${RESOURCE_BASE_PATH}/saveRecentTemplate`, p);
//根据分组ID返回对应的页码
export const getPageNum = p => post(`${RESOURCE_BASE_PATH}/getPageNum`, p);
//ID过滤，查询出客户的权限
export const checkSellerOwnRorNot = p => post(`${RESOURCE_BASE_PATH}/checkSellerOwnRorNot`, p);
// 是否自营
export const publicOpen = id => get(`${RESOURCE_BASE_PATH}/open/jd-crm`,)
